import React from 'react';
import { useMyVar } from '../context/media/MyVarContext';

const Search = () => {
    const {setMyVar } = useMyVar();
    const [inputValue, setInputValue] = React.useState('');
 const handleInputChange=(e)=>{
    setInputValue(e.target.value);
 }
 const DefineVar=(e)=>{
    e.preventDefault();
    setMyVar(inputValue);
 }
    return (
        <div>
            <form className="d-flex " role="search">
                <input className="form-control  rounded-start-pill" type="search" placeholder="Search" aria-label="Search" value={inputValue} onChange={handleInputChange} />
                <button className="btn btn-outline-success rounded-end-circle me-3"  onClick={DefineVar}><i className="bi bi-search"></i></button>
                {/* <button className="btn btn-outline-success rounded-circle" type="submit"><i className="bi bi-mic-fill"></i></button> */}
            </form>
        </div>
    )
}
export default Search
